export default __webpack_public_path__ + "static/media/anthem-website-logos_story_lab.d94c8741.webp";